import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import api from './helpers/Axios'
import storePlugin from './helpers/StorePlugin'
import { BootstrapVue } from 'bootstrap-vue'
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from "vee-validate";
import en from "vee-validate/dist/locale/en.json";
import * as rules from "vee-validate/dist/rules";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHome, faSearch, faUnlock, faUser, faPlus, faExchange, faClock, faBan, faSearchPlus,
  faEdit, faDownload, faEraser, faRepeat, faCalendarAlt, faCalendar, faTimes, faTimesCircle, faCopy,
  faExternalLink, faCheckCircle, faSave, faCheck, faChevronDown, faExclamationTriangle, faPhone,
  faEnvelope, faTag, faKey, faLink, faSpinnerThird, faWrench, faListOl, faList, faPlayCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import moment from 'moment';
import FlagIcon from 'vue-flag-icon'

library.add(faHome, faSearch, faUnlock, faUser, faPlus, faExchange, faClock, faBan, faSearchPlus,
  faEdit, faDownload, faEraser, faRepeat, faCalendarAlt, faCalendar, faTimes, faTimesCircle, faCopy,
  faExternalLink, faCheckCircle, faSave, faCheck, faChevronDown, faExclamationTriangle, faPhone,
  faEnvelope, faTag, faKey, faLink, faSpinnerThird, faWrench, faListOl, faList, faPlayCircle)

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

localize("en", en);

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);


Vue.use(FlagIcon);
Vue.use(Vuex)
Vue.use(storePlugin)

Vue.use(BootstrapVue)

Vue.config.productionTip = false

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 0
  });
  return formatter.format(value);
});

Vue.filter('toCurrency', function (value, prefix){
  if (typeof value !== "number") {
      return value;
  }
  if (prefix){
    return prefix + ' ' + value.toFixed(2);
  }
  var formatter = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 0
  });
  return formatter.format(value);


  
});

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm')
  }
});

Vue.filter('date', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/yyyy')
  }
});

Vue.filter('time', function (value) {
  if (value) {
    return moment(String(value)).format('hh:mm')
  }
});

Vue.prototype.$http = api;

Vue.prototype.$forceCompute= function(computedName) {
	if (this._computedWatchers[computedName]) {
		this._computedWatchers[computedName].run();
		//if (forceUpdate || typeof forceUpdate == 'undefined') this.$forceUpdate()
	}
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

